import { render } from "./MobileAppFormBlock.vue?vue&type=template&id=56973ed8"
import script from "./MobileAppFormBlock.vue?vue&type=script&lang=js"
export * from "./MobileAppFormBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__